import { type VariantProps, cva } from "class-variance-authority";
import type { ComponentPropsWithRef } from "react";
import { cn } from "../../helpers/styles";

export type RibbonProps = Omit<ComponentPropsWithRef<"div">, "color"> &
	VariantProps<typeof ribbonVariants>;

export const Ribbon = ({ children, className, color, ...props }: RibbonProps) => {
	return (
		<div className={cn(ribbonVariants({ color }), className)} {...props}>
			{children}
		</div>
	);
};

Ribbon.displayName = "Ribbon";

const ribbonVariants = cva(
	"flex gap-xs items-center text-white h-5 pl-sm pr-md font-bold text-sm rounded-xxs",
	{
		variants: {
			color: {
				red: "bg-[#E62E05]", // Ribbon specific color not included in the design tokens
				blue: "bg-brand-600",
				yellow: "bg-orange-dark-200 text-black",
				gray: "bg-gray-600",
			},
		},
	},
);

export const RibbonIcon = ({ children, className, ...props }: ComponentPropsWithRef<"span">) => {
	return (
		<span className={cn("flex items-center", className)} {...props}>
			{children}
		</span>
	);
};

RibbonIcon.displayName = "RibbonIcon";

export const RibbonLabel = ({ children, className, ...props }: ComponentPropsWithRef<"span">) => {
	return (
		<span className={cn(className)} {...props}>
			{children}
		</span>
	);
};

RibbonLabel.displayName = "RibbonLabel";

export const RibbonWrapper = ({ children, className, ...props }: ComponentPropsWithRef<"div">) => {
	return (
		<div
			className={cn("absolute left-sm bottom-sm flex flex-col gap-xs items-start", className)}
			{...props}
		>
			{children}
		</div>
	);
};

RibbonWrapper.displayName = "RibbonWrapper";
